export default __webpack_public_path__ + "static/media/Ignacy Kulka.242360c7.png";